module.exports = __webpack_public_path__ + "img/Real-Deal.3bc3aa7e.svg";